export const FIRE_CONFETTI_CANNON = "FIRE_CONFETTI_CANNON"
export const RELOAD_CONFETTI_CANNON = "RELOAD_CONFETTI_CANNON"

/**
 * Fire the confetti cannon. Provide the starting x,y vector
 *
 * @param vector
 * @returns {{type: string, vector: *}}
 */
export const fireConfettiCannon = (vector) => {
  return {
    type: FIRE_CONFETTI_CANNON,
    vector
  }
}


/**
 * Resets the cannon fire flag and the x,y vector ready to be fired again
 *
 * @returns {{type: string}}
 */
export const reloadConfettiCannon = () => {
  return {
    type: RELOAD_CONFETTI_CANNON
  }
}
